module.exports = __webpack_public_path__ + "static/media/avoris.780c1c66.ico";